import React, { useEffect, useRef, useState } from "react";
import { Nav, NavItem, Navbar } from "react-bootstrap";
import { NavLink, NavLink as ReactLink, useNavigate } from "react-router-dom";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Typed from "typed.js";
import {
  doLogout,
  getNetWorthFromLocal,
  getNetworth,
  getUser,
  setNetWorthInLocal,
  getTenantDetails,
  switchBackToAdmin
} from "../../services/user-service";
import Networthpopup from "../popup/networth-popup";
import "./UserNavbar.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useAuth } from "../../auth/AuthContext";

const useNetWorth = () => {
  const [networth, setNetworth] = useState("");
  const [category, setCategory] = useState([]);
  const [coins, setCoins] = useState([]);
  const [netEstimatedValue, setNetEstimatedValue] = useState(0);

  const fetchNetworth = () => {
    const id = getUser().commonId;
    const localStorageNetWorth = getNetWorthFromLocal();
    setNetworth(localStorageNetWorth);
    if (localStorageNetWorth === null) {
      getNetworth(id)
        .then((data) => {
          setNetworth(data.TotalNetWorth);
          setNetWorthInLocal(data.TotalNetWorth);
          const networth = data.TotalNetWorth;
        })
        .catch((error) => {});
    }
  };



  const calculateEstimatedValue1 = (coin1, quntity) => {
    const filteredCoins = coins.filter((coin) => coin.name === coin1);
    if (filteredCoins.length > 0) {
      return parseInt(quntity) * filteredCoins[0].current_price;
    } else {
      return 0;
    }
  };

  const calculateNetEstimatedValue = () => {
    let totalValue = 0;
    for (const row of category) {
      totalValue += calculateEstimatedValue1(row.coin, row.quntity);
    }
    return totalValue;
  };

  useEffect(() => {
    fetchNetworth();

  }, []);

  useEffect(() => {
    const totalValue = calculateNetEstimatedValue();
    setNetEstimatedValue(totalValue);
  }, [category, coins]);

  return { networth, netEstimatedValue };
};

const UserNavbar = ({ hiddenLinks = [] }) => {
  const { networth, netEstimatedValue } = useNetWorth();
  const user = getUser();
  const [tenant, setTenant] = useState(null);
  const navigate = useNavigate();
  const role = (user?.role || '').toUpperCase();

  const { login } = useAuth();

  const isImpersonating = localStorage.getItem("adminToken");

  useEffect(() => {
    if (user?.id) {
      getTenantDetails(user.id).then((res) => {
        setTenant(res);
      });
    }
  }, []);

  const accountType = user?.accountType?.toLowerCase();
  let base = "/user";

  if (role === "TENANT_ADMIN" || role === "TENANT_USER") {
    base = "/organization";
  } else if (role === "ORG_USER") {
    base = "/user";
  } else if (role === "ATTORNEY") {
    base = "/attorney";
  } else if (role === "BENEFICIARY") {
    base = "/beneficiary";
  }

  const ALL_LINKS = [
    { id: "dashboard",     label: "Dashboard",       path: "/dashboard" },
    { id: "why",           label: "Why I-Chest",     path: "/why-I-Chest" },
    { id: "legacy",        label: "Legacy chart",    path: "/legacy-Chart" },
    { id: "owners",        label: "Owners",          path: "/owner" },
    { id: "users",         label: "Users",           path: "/users" },
    { id: "trusts",        label: "Trusts",          path: "/trust" },
    { id: "attorneys",     label: "Attorneys/Agents",path: "/attorney" },
    { id: "beneficiaries", label: "Beneficiaries",   path: "/beneficiary" },
    { id: "help",          label: "Help",            path: "/help" },
  ];

  let visibleLinks = ALL_LINKS;

  if (role === "TENANT_ADMIN" || role === "TENANT_USER") {
    visibleLinks = ALL_LINKS.filter(link =>
      ["dashboard", "why", "owners","users","help"].includes(link.id)
    );
  }

  if (role === "USER") {
    visibleLinks = ALL_LINKS.filter(link =>
      link.id !== "users"
    );
  }

  if (role === "ORG_USER") {
    visibleLinks = ALL_LINKS.filter(link =>
      link.id !== "users"
    );
  }

  const logout = () => {
    doLogout();
    navigate("/");
  };

  const handleExitImpersonation = async () => {
    const success = await switchBackToAdmin();
    if (success) {
      login();
      navigate("/organization/users");
    }
  };

  if (netEstimatedValue !== 0) {
    const totalNetWorth = networth + netEstimatedValue;
    setNetWorthInLocal(totalNetWorth);
  }

  const formattedTotalNetWorth = Number.parseFloat(
    getNetWorthFromLocal()
  ).toFixed(2);

  const [isPopupOpen, setPopupOpen] = useState(false);
  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };
  const popupRef = useRef(null);

  const handleOutsideClick = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setPopupOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const [imageSrc, setImageSrc] = useState("");
  const [organizationName, setOrganizationName] = useState("");

  const base64ToImage = () => {
    const base64String = user.image;
    if (typeof base64String === "string" && base64String.trim()) {
      setImageSrc(`data:image/jpeg;base64,${base64String.trim()}`);
    } else {
      setImageSrc(`${process.env.PUBLIC_URL}/img/avtar.jpg`);
    }
  };

  useEffect(() => {
    base64ToImage();
  }, [user]);

  function addCommasToNumber(number) {
    let numberStr = number.toString();
    numberStr = numberStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return numberStr;
  }
  let formattedNetworthValue = addCommasToNumber(formattedTotalNetWorth);

  const [isPopupNetworthOpen, setIsNetworthPopupOpen] = useState(false);

  const toggleNetworthPopup = () => {
    setIsNetworthPopupOpen(!isPopupNetworthOpen);
  };

  return (
    <div>
      <Navbar className="navbar " expand="lg" bg="dark" variant="dark">
        <Navbar.Brand className="navbar-logo">
          <NavLink tag={ReactLink} to={base + "/dashboard"}>
            <LazyLoadImage
              className="navbar_logo_image"
              src={`${process.env.PUBLIC_URL}/logo192.webp`}
              alt="logoPng"
            />
          </NavLink>
        </Navbar.Brand>

        <Navbar.Toggle
          className="navbar-toggler"
          aria-controls="basic-navbar-nav"
          style={{ marginRight: "20px" }}
        />
        <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {visibleLinks.map(link => (
                <Link
                  key={link.id}
                  className="navname navbar_link"
                  smooth="true"
                  duration={50}
                  tag={ReactLink}
                  to={base + link.path}
                >
                  {link.label}
                </Link>
              ))}
            </Nav>

          <Nav navbar style={{ alignItems: "center" }}>
            {isImpersonating && (
              <button
                onClick={handleExitImpersonation}
                style={{
                  marginRight: "15px",
                  padding: "6px 12px",
                  backgroundColor: "#d32f2f",
                  color: "white",
                  border: "1px solid #b71c1c",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "13px"
                }}
              >
                Exit Impersonation
              </button>
            )}

            <NavItem>
              <NavLink onClick={togglePopup} className="nav-user-name">
                <img
                    src={imageSrc}
                    alt="avatar_image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `${process.env.PUBLIC_URL}/img/avtar.jpg`;
                    }}
                  />
                <div className="navbar_username ">
                  {role === "tenant_admin"
                      ? (organizationName || "Organization")
                    : `${user.firstName || ""} ${user.lastName || ""}`}

                  {role === "TENANT_ADMIN" && tenant && (
                    <div style={{ fontSize: "12px", color: "#ddd" }}>
                      {tenant.organizationName}
                    </div>
                  )}
                </div>

                <FontAwesomeIcon
                  style={{ marginLeft: "10px" }}
                  icon={faCaretDown}
                />
              </NavLink>
            </NavItem>

           {isPopupOpen && (
            <div ref={popupRef} className="popup1">
              <ul>
                {tenant && (
                  <li className="navbar_link" style={{ cursor: "default", fontWeight: "bold" }}>
                    {tenant.organizationName} ({tenant.contactNumber})
                  </li>
                )}
                <Link to={base + "/profile"} className="navbar_link">
                  Profile
                </Link>

                <Link to={base + "/dashboard"} className="navbar_link">
                  Dashboard
                </Link>

                <Link to={base + "/help"} className="navbar_link">
                  Help
                </Link>

                <a style={{ color: "#5e6576" }} onClick={logout}>
                  Logout
                </a>
              </ul>
            </div>
          )}

          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};
export default UserNavbar;
